import styled from 'styled-components';
import { styles } from '../../../../../consts';

const { breakLineColor } = styles;

export const LineBreak = styled.div`
  margin: 0.8125rem 0;
  height: 0.0625rem;
  background: ${breakLineColor};
`;

const setHeight = ({ height }: { height: number }) => height;

export const Wrapper = styled.div<{ height: number }>`
  height: 0;
  height: ${setHeight}px;
  transition: height 400ms ease-in-out;
`;

export const CheckboxWrapper = styled.div``;
